export default __webpack_public_path__ + "8fc0d6a03b5f20a23b6e516d80d0d37d.png";